export default __webpack_public_path__ + "static/media/liked-full.1e7c9bff.svg";